// common
export const PUT_REQUEST = 'appointmentDates/PUT_REQUEST'
export const PUT_SUCCESS = 'appointmentDates/PUT_SUCCESS'
export const PUT_FAILURE = 'appointmentDates/PUT_FAILURE'